export const initCatalogMenu = () => {
	// prevent re-initialization
	if (window.app?.catalogMenuInitialized) return;
	window.app.catalogMenuInitialized = true;

	const menuButtons = document.querySelectorAll('.js-catalog-button');
	const closeButton = document.querySelector('.catalog-menu__close-button');
	const catalogMenu = document.querySelector('.catalog-menu');
	const modalLayer = document.querySelector('.js-modal-layer');

	menuButtons.forEach((button) => {
		button.addEventListener('click', (e) => handleMenuButtonClick(button, e));
	});

	closeButton?.addEventListener('click', handleCloseButtonClick);

	function handleMenuButtonClick(button, e) {
		e.preventDefault();
		if (!button.classList.contains('catalog-menu--active')) {
			window.app.modal.open('#catalog-menu');
		} else {
			window.app.modal.close();
		}
	}

	function handleCloseButtonClick() {
		menuButtons.forEach((button) => button.classList.remove('catalog-menu--active'));
		modalLayer.classList.add('modal-layer--catalog--closing');
		setTimeout(() => {
			modalLayer.classList.remove('modal-layer--catalog', 'modal-layer--catalog--closing');
		}, 400);
	}

	function handleModalOpen() {
		modalLayer.classList.add('modal-layer--catalog');
		menuButtons.forEach((button) => button.classList.add('catalog-menu--active'));
	}

	initCatalogCategorySwitching();

	catalogMenu?.addEventListener('modalOpen', handleModalOpen);
	catalogMenu?.addEventListener('modalClose', handleCloseButtonClick);
};

function initCatalogCategorySwitching() {
	const buttons = document.querySelectorAll('.catalog-menu-button');
	const categories = document.querySelectorAll('.catalog-menu-category');
	const desktopMQ = window.matchMedia(`(min-width: ${vars.breakpoint.laptop}px)`);

	function activateCategory(id) {
		buttons.forEach((btn) => btn.classList.toggle('catalog-menu-button--active', btn.dataset.catalogCategory === id));
		categories.forEach((cat) => cat.classList.toggle('catalog-menu-category--active', cat.dataset.catalogCategory === id));
	}

	buttons.forEach((button) => {
		const categoryId = button.dataset.catalogCategory;

		function handleInteraction(e) {
			if (desktopMQ.matches) {
				e.preventDefault();
				activateCategory(categoryId);
			}
		}

		button.addEventListener('click', handleInteraction);
		button.addEventListener('mouseover', handleInteraction);
	});
}
